import EddQuestions from 'features/signup/EddQuestions/EddQuestions';
import React from 'react';

export default function Page() {
  return <EddQuestions />;
}
